import {isNotNil} from 'ramda';

import type {Money} from '@dms/api/shared';
import {useGetSaleVehicleLeasingQuery} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

import {applyDefaultLeasingListPrice} from '../utils/applyDefaultLeasingListPrice';
import {configurationToLeasingBody} from '../utils/configurationToLeasingBody';

interface UseLeasingOverviewParams {
  saleVehicleId: string;
  vehiclePrice: Money | Nullish;
  isCreateAllowed: boolean;
  isUpdateAllowed: boolean;
}

export function useLeasingOverview(params: UseLeasingOverviewParams) {
  const {
    data: overview,
    isLoading,
    isError,
  } = useGetSaleVehicleLeasingQuery({saleVehicleId: params.saleVehicleId});

  const configuration = overview?.configuration;
  const persistedBody = isNotNil(configuration) ? configurationToLeasingBody(configuration) : null;
  const baselineBody = isNotNil(persistedBody)
    ? applyDefaultLeasingListPrice(persistedBody, params.vehiclePrice)
    : null;
  const isPersisted = isNotNil(configuration);

  return {
    isLoading,
    isError,
    state: overview?.state,
    baselineBody,
    isPersisted,
    isWriteAllowed: isPersisted ? params.isUpdateAllowed : params.isCreateAllowed,
  };
}
